import { ensureInitialized } from '../internal/internalAPIs';
import { FrameContexts } from './constants';
import { pages } from './pages';

/**
 * @deprecated with Teams JS v2 upgrades
 *
 * Namespace to interact with the settings-specific part of the SDK.
 * This object is usable only on the settings frame.
 */
export namespace settings {
  /**
   * @deprecated with Teams JS v2 upgrades
   * @remarks
   * Renamed to config in pages.Config
   */
  export import Settings = pages.config.Config;

  /**
   * @deprecated with Teams JS v2 upgrades
   * @remarks
   * See pages.SaveEvent
   */
  export import SaveEvent = pages.config.SaveEvent;

  /**
   * @deprecated with Teams JS v2 upgrades
   * @remarks
   * See pages.RemoveEvent
   */
  export import RemoveEvent = pages.config.RemoveEvent;

  /**
   * @deprecated with Teams JS v2 upgrades
   * @remarks
   * See pages.SaveParameters
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export import SaveParameters = pages.config.SaveParameters;

  /**
   * @deprecated with Teams JS v2 upgrades
   *
   * Sets the validity state for the settings.
   * The initial value is false, so the user cannot save the settings until this is called with true.
   *
   * @param validityState - Indicates whether the save or remove button is enabled for the user.
   */
  export function setValidityState(validityState: boolean): void {
    pages.config.setValidityState(validityState);
  }

  /**
   * @deprecated with Teams JS v2 upgrades
   *
   * Gets the settings for the current instance.
   *
   * @param callback - The callback to invoke when the {@link Settings} object is retrieved.
   */
  export function getSettings(callback: (instanceSettings: Settings) => void): void {
    ensureInitialized(FrameContexts.content, FrameContexts.settings, FrameContexts.remove, FrameContexts.sidePanel);
    pages.config.getConfig().then((config: pages.config.Config) => {
      callback(config);
    });
  }

  /**
   * @deprecated with Teams JS v2 upgrades
   *
   * Sets the settings for the current instance.
   * This is an asynchronous operation; calls to getSettings are not guaranteed to reflect the changed state.
   *
   * @param - Set the desired settings for this instance.
   */
  export function setSettings(
    instanceSettings: Settings,
    onComplete?: (status: boolean, reason?: string) => void,
  ): void {
    ensureInitialized(FrameContexts.content, FrameContexts.settings, FrameContexts.sidePanel);
    pages.config
      .setConfig(instanceSettings)
      .then(() => {
        if (onComplete) {
          onComplete(true);
        }
      })
      .catch((error: Error) => {
        if (onComplete) {
          onComplete(false, error.message);
        }
      });
  }

  /**
   * @deprecated with Teams JS v2 upgrades
   *
   * Registers a handler for when the user attempts to save the settings. This handler should be used
   * to create or update the underlying resource powering the content.
   * The object passed to the handler must be used to notify whether to proceed with the save.
   * Only one handler can be registered at a time. A subsequent registration replaces an existing registration.
   *
   * @param handler - The handler to invoke when the user selects the save button.
   */
  export function registerOnSaveHandler(handler: (evt: SaveEvent) => void): void {
    pages.config.registerOnSaveHandler(handler);
  }

  /**
   * @deprecated with Teams JS v2 upgrades
   *
   * Registers a handler for user attempts to remove content. This handler should be used
   * to remove the underlying resource powering the content.
   * The object passed to the handler must be used to indicate whether to proceed with the removal.
   * Only one handler may be registered at a time. Subsequent registrations will override the first.
   *
   * @param handler - The handler to invoke when the user selects the remove button.
   */
  export function registerOnRemoveHandler(handler: (evt: RemoveEvent) => void): void {
    pages.config.registerOnRemoveHandler(handler);
  }
}
